__turbopack_context__.v({
  "cardWithTitleWrapper": "cardWithTitle-module-scss-module__fOdt7a__cardWithTitleWrapper",
  "title": "cardWithTitle-module-scss-module__fOdt7a__title",
});
